var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.7188C13.468 12.7188 15.4688 10.718 15.4688 8.25C15.4688 5.78198 13.468 3.78125 11 3.78125C8.53198 3.78125 6.53125 5.78198 6.53125 8.25C6.53125 10.718 8.53198 12.7188 11 12.7188Z",
    stroke: "#71717A",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 19.5938C3.78125 16.1562 6.53125 12.7188 11 12.7188C15.4688 12.7188 18.2188 16.1562 18.2188 19.5938",
    stroke: "#71717A",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.19c914b8486b14269e540e5b32ac8458.svg";
export { ForwardRef as ReactComponent };